module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-users"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        Users.\n      ")]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('b-table', {
    attrs: {
      "data": _vm.tableData,
      "bordered": _vm.isBordered,
      "striped": _vm.isStriped,
      "narrowed": _vm.isNarrowed,
      "checkable": _vm.isCheckable,
      "loading": _vm.isLoading,
      "mobile-cards": _vm.hasMobileCards,
      "paginated": _vm.isPaginated,
      "per-page": 50,
      "pagination-simple": true,
      "default-sort": "user.first_name",
      "selected": _vm.selected,
      "checked-rows": _vm.checkedRows
    },
    on: {
      "update:selected": function($event) {
        _vm.selected = $event
      },
      "update:checkedRows": function($event) {
        _vm.checkedRows = $event
      }
    }
  }, [
    [_c('b-table-column', {
      attrs: {
        "field": "identifier",
        "label": "ID",
        "width": "40",
        "sortable": "",
        "numeric": ""
      }
    }, [_vm._v("\n            " + _vm._s(_vm.props.row.identifier) + "\n          ")]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "username",
        "label": "User Name",
        "sortable": ""
      }
    }, [_vm._v("\n            " + _vm._s(_vm.props.row.username) + "\n          ")]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "email",
        "label": "Email",
        "sortable": ""
      }
    }, [_vm._v("\n            " + _vm._s(_vm.props.row.email) + "\n          ")]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "role",
        "label": "Role",
        "sortable": ""
      }
    }, [_c('span', {
      staticClass: "tag",
      class: {
        'is-warning': (_vm.props.row.role === 'root'),
        'is-danger': (_vm.props.row.role === 'admin'),
        'is-success': (_vm.props.row.role === 'user')
      }
    }, [_vm._v("\n              " + _vm._s(_vm.props.row.role) + "\n            ")])]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "isVerified",
        "label": "Verified",
        "sortable": ""
      }
    }, [_c('b-icon', {
      attrs: {
        "pack": "mdi",
        "icon": _vm.props.row.isVerified ? 'done' : 'close'
      }
    })], 1)], _vm._v(" "), _c('div', {
      staticClass: "has-text-centered",
      attrs: {
        "slot": "empty"
      },
      slot: "empty"
    }, [_c('span', {
      staticStyle: {
        "color": "#ccc"
      }
    }, [_vm._v("Table contains nothing.")])])
  ], 2)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ebb5329e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages_auth/Users.vue
// module id = 841
// module chunks = 1